import React from 'react';
import { Button, Dialogs } from '@leverege/ui-elements';
import LocatorDialog from './LocatorDialog';
import { isReconcilableBusinessState } from './Util';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY = {};
function checkStatus(locator) {
  const businessState = locator?.data?.data?.businessState;
  return isReconcilableBusinessState(businessState);
}
function LocatorReconciliationDetailRenderer(props) {
  const {
    object,
    cxt
  } = props;
  const {
    clientProps: {
      actions
    }
  } = cxt;
  const openDialog = () => {
    Dialogs.show({
      id: 'requestLocatorPosition',
      component: LocatorDialog,
      props: {
        actions,
        locator: object,
        context: cxt
      }
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    variant: "secondary",
    onClick: openDialog,
    disabled: !checkStatus(object),
    children: "Request Locator Position"
  });
}
export default class LocatorDetailRenderer {
  getValueComponent(object, cxt) {
    return /*#__PURE__*/_jsx(LocatorReconciliationDetailRenderer, {
      object: object,
      cxt: cxt
    });
  }
  getComponents(object, cxt = EMPTY) {
    return [{
      style: {},
      component: this.getValueComponent(object, cxt)
    }];
  }
}